<template>
  <div v-if="route.name == 'NotFound'" class="flex h-screen">
    <router-view />
  </div>
  <div
    v-else-if="
      currentUserStore.allDataLoaded &&
      (route.name == 'MonitoringOrder' || route.name == 'MonitoringTwoOrder')
    "
    class="flex h-screen"
  >
    <main class="w-full h-full">
      <router-view />
    </main>
  </div>
  <div v-else-if="currentUserStore.allDataLoaded" class="flex h-screen">
    <div>
      <div
        class="border-r-[var(--select-border-color)] border-r-2 h-screen overflow-x-hidden main-sidebar bg-[var(--background-color)] absolute md:static z-[1000]"
        :class="visible ? 'w-[250px]' : 'w-[0px] md:w-[50px]'"
      >
        <div class="flex flex-col h-full">
          <div class="flex items-center justify-between px-3">
            <div />
            <div class="flex items-center justify-end">
              <div class="h-[90px]">
                <img
                  v-if="visible"
                  :src="themeStore.theme === 'p-dark' ? lightLogo : darkLogo"
                  class="h-[30px] object-fill mt-8"
                />
                <img
                  v-else
                  :src="themeStore.theme === 'p-dark' ? WadeLightLogo : WadeDarkLogo"
                  class="h-[20px] object-fill mt-8"
                />
              </div>
            </div>
            <div>
              <div v-if="visible" class="md:hidden p-2 cursor-pointer" @click="visible = !visible">
                <i class="pi pi-times" />
              </div>
            </div>
          </div>
          <div class="sidebar-panel-menu">
            <PanelMenu
              :multiple="false"
              :model="sidebarItems"
              :expanded-keys="expandedKeys"
              @update:expanded-keys="handleUpdateExpandedKeys"
            >
              <template #item="{ item }">
                <div v-if="item.label == 'Chat'">
                  <RouterLink :to="{ name: item.path }">
                    <div
                      v-can="item.can"
                      :path="{
                        name: item.path
                      }"
                      @click="() => (visible = true)"
                    >
                      <div
                        class="px-4 py-2 cursor-pointer h-[38px] overflow-hidden"
                        :style="isActive(item.path) ? 'color: var(--p-primary-color)' : ''"
                        @click="
                          () => {
                            router.push({
                              name: item.path
                            })
                          }
                        "
                      >
                        <div class="flex items-center justify-between gap-2">
                          <div class="flex items-center gap-2">
                            <i :class="item.icon" />
                            <span v-if="visible">{{ item.label }}</span>
                          </div>
                          <div
                            v-if="
                              notificationStore.messages.filter(
                                (message) =>
                                  !message.isRead && message.senderUserRoleType !== RoleType.PANEL
                              ).length > 0
                            "
                          >
                            <div
                              class="h-[20px] w-[20px] bg-[#0ea5e9] rounded-full flex justify-center items-center"
                            >
                              <h1 class="text-white text-xs">
                                {{
                                  notificationStore.messages.filter(
                                    (message) =>
                                      !message.isRead &&
                                      message.senderUserRoleType !== RoleType.PANEL
                                  ).length
                                }}
                              </h1>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </RouterLink>
                </div>
                <RouterLink v-else :to="{ name: item.path }">
                  <div
                    v-can="item.can"
                    :path="{
                      name: item.path
                    }"
                    @click="() => (visible = true)"
                  >
                    <div
                      class="px-4 py-2 cursor-pointer h-[38px] overflow-hidden"
                      :style="
                        isActive(item.path)
                          ? 'color: var(--p-primary-color)'
                          : item.label == 'Translations' && unTranslated
                            ? 'color: var(--p-orange-400)'
                            : ''
                      "
                      @click="
                        () => {
                          router.push({
                            name: item.path
                          })
                        }
                      "
                    >
                      <div class="flex items-center justify-between gap-2">
                        <div class="flex items-center gap-2">
                          <i :class="item.icon" />
                          <span v-if="visible">{{ item.label }}</span>
                        </div>
                        <i v-if="item.items && visible" class="pi pi-chevron-down" />
                      </div>
                    </div>
                  </div>
                </RouterLink>
              </template>
            </PanelMenu>
          </div>
        </div>
      </div>
    </div>
    <div class="flex-1 flex flex-col overflow-auto" style="width: calc(100vw - 246px)">
      <div class="w-full">
        <Toolbar
          style="border-radius: 0rem; padding: 10px 20px"
          :style="`background-color: ${isDev() ? 'var(--Completed-opacity)' : ''}`"
        >
          <template #start>
            <Button
              icon="pi pi-bars"
              class="p-button-primary"
              @click="
                () => {
                  expandedKeys = {}
                  visible = !visible
                }
              "
            />
            <div class="card flex justify-center items-center mx-2">
              <a :href="`${mainPanelUrl}`">
                <div class="p-1 cursor-pointer">
                  <i class="pi pi-home mt-1" style="font-size: 20px" />
                </div>
              </a>
              <Breadcrumb :model="breadCrumbData">
                <template #item="{ item }">
                  <div
                    class="cursor-pointer"
                    @click="
                      () => {
                        if (route.name === 'OrderDetail' || route.name === 'ItemDetail') {
                          goBack()
                        } else if (item.path) {
                          router.push({
                            name: item.path
                          })
                        }
                      }
                    "
                  >
                    {{ item.label }}
                  </div>
                </template>
              </Breadcrumb>
              <Skeleton v-if="loadingStorage.hasLoading('headline')" width="100px" height="20px" />
            </div>
          </template>

          <template #end>
            <div class="flex items-center gap-2 px-[0px] md:px-[30px]">
              <div>
                <!-- <MessageNotification /> -->
              </div>
              <div
                class="hover:bg-[var(--content-background)] w-[25px] h-[25px] flex justify-center items-center rounded-sm"
              >
                <ThemeSwitcher />
              </div>
              <div v-if="hasPolicy(marketPolicyType.VIEW_SUPPORT_MESSAGES)">
                <NotificationIcon />
              </div>

              <div
                class="cursor-pointer flex justify-center items-center gap-2"
                @click="(event) => openAvatarPopover.toggle(event)"
              >
                <img
                  v-if="currentUserStore.userData?.photoUrl"
                  :src="getImageFullUrl(currentUserStore.userData.photoUrl)"
                  class="w-[32px] h-[32px] rounded-[5px]"
                />
                <Avatar
                  v-else
                  :label="currentUserStore.userData?.displayName?.charAt(0)"
                  class="w-[32px] h-[32px]"
                />
                {{ currentUserStore?.userData?.displayName }}
              </div>
              <TieredMenu
                ref="openAvatarPopover"
                :model="items"
                popup
                class="mt-[10px]"
                style="min-width: 150px !important; margin-top: 10px !important"
              />
            </div>
          </template>
        </Toolbar>
      </div>
      <main class="flex-1 p-4 max-h-[calc(100vh-70px)] overflow-auto">
        <router-view />
      </main>
    </div>
  </div>
  <div
    v-else
    :class="`flex justify-center items-center h-screen `"
    :style="`background-color: ${splashBackground};`"
  >
    <Vue3Lottie :animation-data="LoadingLottie" />
    <router-view />
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref, watch } from 'vue'
import { sidebarItems } from './sidebarItems'
import { useRoute, useRouter } from 'vue-router'
import ThemeSwitcher from '@/components/ThemeSwitcher.vue'
import { useCurrentUserStore } from '@/features/currentUser/presentation/stores/currentUserStore'
import { Vue3Lottie } from 'vue3-lottie'

import { getImageFullUrl } from '@/utils/getImageFullUrl'
import { useAuthenticationStore } from '@/features/authentication/presentation/stores/useAuthenticationStore'

import eventBus from '@/utils/eventBus'

import lightLogo from '@/images/whiteLogo.png'
import darkLogo from '@/images/darklogo.png'

import WadeLightLogo from '@/images/wadeLightLogo.png'
import WadeDarkLogo from '@/images/wadeDarkLogo.png'
import LoadingLottie from '@/images/loading.json'
import { loadingStorage } from '@/utils/loadingCache'
import NotificationIcon from '@/features/chat/presentation/components/headerChatNotification/NotificationIcon.vue'
import { useNotificationStore } from '@/features/chat/presentation/stores/notificationStore'
import { RoleType } from '@/features/role/domain/enums/RoleType'
import { marketPolicyType } from '@/shared/enums/marketPolicyType'
import { useThemeStore } from '@/shared/stores/themeStore'

const authenticationStore = useAuthenticationStore()
const currentUserStore = useCurrentUserStore()
const route = useRoute()
const router = useRouter()
const notificationStore = useNotificationStore()
const splashBackground = ref()
const expandedKeys = ref<Record<string, boolean>>({})
const openAvatarPopover = ref()
const visible = ref(true)
const sidebarVisibleBeforeOrderDetail = ref<boolean | undefined>()
const unTranslated = ref(false)
const breadCrumbData = ref<
  {
    label: string
    path?: string
  }[]
>([])

const mainPanelUrl = Object.create(globalThis.import_meta_env || null).VITE_MAIN_URL
const themeStore = useThemeStore()
const items = ref([
  {
    label: 'Profile',
    icon: 'pi pi-user',
    command: () => {
      router.push({ name: 'UserProfile' })
    }
  },
  {
    label: 'Reset Password',
    icon: 'pi pi-unlock',
    command: () => {
      // dialog.open(ResetPassword, {
      //   props: {
      //     header: 'Reset Password',
      //     modal: true
      //   }
      // })
    }
  },
  {
    label: 'Logout',
    icon: 'pi pi-sign-out',
    command: () => {
      authenticationStore.logout()
    }
  }
])

let themeClass = localStorage.getItem('themeClass')

watch(
  () => route.name,
  (routeName, previousRouteName) => {
    const isOrderDetail = routeName === 'OrderDetail'
    const wasOrderDetail = previousRouteName === 'OrderDetail'

    if (isOrderDetail && !wasOrderDetail) {
      sidebarVisibleBeforeOrderDetail.value = visible.value
      visible.value = false
      return
    }

    if (!isOrderDetail && wasOrderDetail && sidebarVisibleBeforeOrderDetail.value !== undefined) {
      visible.value = sidebarVisibleBeforeOrderDetail.value
      sidebarVisibleBeforeOrderDetail.value = undefined
    }
  },
  { immediate: true }
)

onMounted(async () => {
  eventBus.on('page-title-updated', (title: string) => {
    if (title === 'loading') {
      breadCrumbData.value[breadCrumbData.value.length - 1].label = ''
      return
    }
    breadCrumbData.value[breadCrumbData.value.length - 1].label = title
  })
  const root = document.getElementsByTagName('html')[0]
  root.classList.remove('p-dark')
  root.classList.add(!themeClass ? 'no' : themeClass)

  setTimeout(async () => {
    splashBackground.value = localStorage.getItem('themeClass') ? '#121212' : '#f1f5f9'
    findParentKeyByRouteName(route.name)
      ? (expandedKeys.value[findParentKeyByRouteName(route.name) as string] = true)
      : (expandedKeys.value = {})
  }, 1000)
})

function isActive(path: string) {
  return route.name && path && route.name === path
}
const handleUpdateExpandedKeys = (keys: {}) => {
  expandedKeys.value = keys
}
const findParentKeyByRouteName = (routeName: string | undefined | symbol): string | undefined => {
  for (const item of sidebarItems) {
    if (item.path && item.path === routeName) {
      return item.key
    }
    if (item.items) {
      for (const child of item.items) {
        if (child.path === routeName) {
          return item.key?.toString()
        }
      }
    }
  }
  return undefined
}
const getRouteNameByPath = (path: string) => {
  const cleanPath = path?.split('?')[0]
  const route = router?.getRoutes().find((r) => r.path === `/${cleanPath}`)
  return route ? route.name : undefined
}

function isDev() {
  return Object.create(globalThis.import_meta_env || null).VITE_MARKET_URL?.includes('dev.a')
}
watch(
  () => route,
  () => {
    breadCrumbData.value = []
    route.path
      .replace(/^\//, '')
      .split('/')
      .map((value) => {
        breadCrumbData.value.push({
          label: value,
          path: getRouteNameByPath(value) as string
        })
      })
  },
  { immediate: true, deep: true }
)

const goBack = () => {
  const from = route.query.from as string
  if (from === 'stream') {
    router.push({ name: 'OrderStream' })
  } else if (from === 'list') {
    router.push({ name: 'OrderList' })
  } else {
    router.back()
  }
}

function hasPolicy(policy: string) {
  return currentUserStore.allPolicies.includes(policy)
}
</script>
<style lang="scss">
.main-sidebar {
  transition: width 0.3s ease-in-out;
  ::-webkit-scrollbar {
    display: none !important;
  }
}

.p-toolbar {
  border-left: none !important;
  border-right: none !important;
}
.sidebar-panel-menu {
  .p-panelmenu-panel {
    border-width: 0 !important;
    background: transparent !important;
    padding: 0 !important;
    .p-panelmenu-header-link {
      padding: 5px 10px !important;
    }
    .p-panelmenu-content {
      padding-bottom: 20px !important;
      .p-menuitem:last-child {
        .p-menuitem-link {
          padding-bottom: 20px !important;
        }
      }
    }
  }
}

// Additional targeting for dropdown menu items
.p-panelmenu .p-panelmenu-content .p-menuitem:last-child {
  margin-bottom: 20px !important;
}

.p-panelmenu .p-panelmenu-content .p-menuitem:last-child .p-menuitem-link {
  padding-bottom: 20px !important;
}

.p-breadcrumb {
  .p-menuitem-text {
    cursor: pointer;
    &:hover {
      color: var(--primary-color);
    }
  }
}
</style>
